export const GENERIC_ERROR_TOAST_DESCRIPTION =
  'Something went wrong. Please try again.';
